import React, { Component } from 'react';
import { toast } from 'react-toastify'
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import AdmissionApi from '../../../Services/AdmissionApi';
import Paging from "../../Paging";
import ImgLoading from '../../../assets/images/img-loading.gif'
import './style.css';

const createMarkup = (data) => {
  if (data) {
    if (data.substring().length > 70) {
      return { __html: data.substring(3, 70) + "..." };
    } else {
      return { __html: data.substring(3, 70) };
    }

  } else {
    return { __html: <p></p> };
  }
}

class AdminCareers extends Component {

  constructor(props) {
    super(props);
    this.state = {
      detail: false,
      careers: [],
      imagesId: [],
      images: [],
      selectedCareer: '',
      page: 1,
      pageSize: 10,
      totalPages: 1
    }

    this._openModal = this._openModal.bind(this);
    this.handleState = this.handleState.bind(this);
    this.deleteItem = this.deleteItem.bind(this);
    this.updateListData = this.updateListData.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.admissionsService = new AdmissionApi();
  }


  _openModal(item) {
    this.props.showForm(item);
  }

  handleState(value, data) {
    this.setState({
      detail: value
    })

    this.props.sendDetail(value, data);
  }

  updateImageState = (newResponse) => {
    let images = [];
    let newCareers = [];

    let careers = this.state.careers;
    images = newResponse.data.images;
    if (newResponse.data.success) {
      careers.map((item, _index) => {
        images.map((obj, index) => {

          if (item.imageid != null || item.imageid != undefined) {
            if (item.imageid == obj.id) {
              item.imageurl = "https://media.notifyi.in/" + obj.url;
              newCareers.push(item);
            }
          } else {
            if (newCareers.length > 0) {
              newCareers.forEach((newCar, i) => {
                if (newCar.id == item.id) {

                } else {
                  if (newCareers.length == i + 1) {
                    newCareers.push(item);
                  }
                }
              })
            } else {
              newCareers.push(item);
            }
          }
        })
      });

      this.setState({ careers: newCareers, images: images });
    }
  }

  updateState = (newResponse) => {

    let ids = [];
    let careers = [];
    careers = newResponse.data._embedded.careers;
    careers.map((item) => ids.push(item.imageid))

    let data = { images: ids }
    this.admissionsService.createMediaNew(this.updateImageState, data, 'v1/media/images/get-all');
    this.setState({
      careers: careers,
      imagesId: ids,
      page: newResponse.data.page,
      totalPages: newResponse.data.pageCount
    });
  }

  deleteItem(item) {
    confirmAlert({
      title: 'Confirm ?',
      message: 'Are You Sure you want to delete ?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            this.admissionsService.deleteCredentials(
              res => {
                if(res.status === 200) {
                  toast.success(("Career deleted successfully."))
                  this.updateData()
                }
              }, 
              'v1/career', 
              item.id
            );
          }
        },
        {
          label: 'No',
          onClick: () => {
            console.log("Cancel");
          }
        }
      ]
    })
  }

  updateData = (newResponse) => {
    this.getData();
  }

  getData(page = 1) {

    let filters = ''
    const {
      selectedCareer,
      pageSize
    } = this.state

    if (selectedCareer) filters += `&text=${selectedCareer}`

    this.admissionsService.GetData(
      this.updateState,
      `v1/career?page=${page}&pageSize=${pageSize}&column=created_at&order=desc${filters}`
    )
  }

  updateListData = (data) => {
    if (data) {
      this.updateState(data);
    } else {
      this.getData();
    }
  }

  UNSAFE_componentWillMount() {
    this.getData();
  }

  handleFilterInputChange = (event) => {
    const { id, value } = event.target
    this.setState({
      [id]: value
    })
  }

  filterList = () => {
    this.getData()
  }

  clearFilter = () => {
    this.setState({
      selectedCareer: ''
    }, this.getData)
  }

  handlePageChange = (page) => {
    this.getData(page)
  }

  render() {
    const {
      page,
      totalPages,
      selectedCareer,
      careers
    } = this.state

    const { showDetails, updateRoutePage } = this.props

    return (
      <section className="dash-alerts">
        <div className="alert-filter">
          <input
            id="selectedCareer"
            value={selectedCareer}
            type="text"
            className="form-control alert-filter__input mr-2"
            placeholder="Search for career"
            onChange={this.handleFilterInputChange}
          />
          <button onClick={this.filterList} className="btn btn--primary">
            Submit
          </button>
          <button onClick={this.clearFilter} className="btn btn--default ml-2">
            Clear
          </button>
          <button onClick={() => updateRoutePage('new-career')} className='btn btn--new ml-2'>
            <i className="icon-plus" />
          </button>
        </div>
        <table className="table table-responsive career-table alert-table">
          <thead>
            <tr>
              <th scope="col">Career</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {careers.map(item => (
              <tr key={item.id}>
                <td className='career-body'>
                  <img className="career-img" src={item.imageurl ? item.imageurl : ImgLoading} alt={item.title} />
                  <div className="career-content">
                    <h3>{item.title}</h3>
                    <p className='d-none d-lg-block' dangerouslySetInnerHTML={createMarkup(item.domain)}></p>
                  </div>
                </td>
                <td className='d-flex'>
                  <button className="btn btn-link alert-table__link" onClick={() => showDetails('career-details', item)}>
                    <i className="icon-eye" />
                  </button>
                  <button className="btn btn-link alert-table__link" onClick={() => showDetails('new-career', item)}>
                    <i className="icon-pencil" />
                  </button>
                  <button className="btn btn-link alert-table__link" onClick={() => this.deleteItem(item)}>
                    <i className="icon-trash" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <Paging page={page} totalPages={totalPages} onChange={this.handlePageChange} />
      </section>
    )
  }
}

export default AdminCareers



/** WEBPACK FOOTER **
 ** ./src/components/Admin/AdminCareers/index.js
 **/